import { useCountryPromptModalStore } from '@/stores/countryPromptModal';
import { CountryPromptModal } from './CountryPromptModal';

export function CountryPromptModalProvider() {
  const open = useCountryPromptModalStore((s) => s.open);
  const setOpen = useCountryPromptModalStore((s) => s.setOpen);

  return <CountryPromptModal open={open} onOpenChange={setOpen} />;
}
